import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Courses from './Courses';

const path = window.location.pathname;
const Page = path === '/courses' ? Courses : App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Page />);